import { Col, Row } from "antd";
import { PricingCard, PricingCardProps } from "./PricingCard/web";

import React from "react";
import { useTheme } from "../../../Styles/ThemeHook";

export const PricingCards = ({ data }: { data: Array<PricingCardProps> }) => {
	const { theme } = useTheme();

	return (
		<Row gutter={[theme.spacing.xlSpacing, theme.spacing.xlSpacing]} className="pricing-cards">
			{data.map((e, i) => (
				<Col key={"pricing-card" + i} lg={data.length != 3 ? 6 : 8} md={12} sm={12} xs={24}>
					<PricingCard {...e} />
				</Col>
			))}
		</Row>
	);
};
